import { BookingFormValidator } from "./booking-form-validator";

export function initCheckoutPage(paymentService: any): void {
    const $: any = (window as any).$;
    if (!$) return;

    const form = document.getElementById("EventBookingForm") as HTMLFormElement | null;
    if (!form) return;

    const terms = form.querySelector<HTMLInputElement>("#TermsAllAgreed");
    if (!terms) return;

    // Use shared validator to setup terms validation
    BookingFormValidator.setupTermsValidation("EventBookingForm");

    // Wire invoice button -> payment service method
    const invoiceBtn = document.getElementById("invoiceButton") as HTMLElement | null;
    if (invoiceBtn) {
        invoiceBtn.setAttribute("type", "button"); // hard guarantee
        invoiceBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (!paymentService || typeof paymentService.submitEventInvoiceFromButton !== "function") {
                console.error("[checkout] paymentService missing submitEventInvoiceFromButton");
                return;
            }

            paymentService.submitEventInvoiceFromButton(invoiceBtn);
        });
    }

    const poInput = document.getElementById("PoNumber") as HTMLInputElement | null;
    const poError = document.getElementById("PoNumberError") as HTMLElement | null;

    if (poInput) {
        poInput.addEventListener("input", () => {
            if (poInput.value.trim().length) {
                poInput.classList.remove("input-validation-error");
                if (poError) {
                    poError.textContent = "";
                    poError.classList.add("d-none");
                }
            }
        });
    }
}

export function initStudyMaterialsHelpText() {
    // Delivery / Collection help text toggle
    const deliveryRadio = document.getElementById(
        "deliveryMethod_delivery"
    ) as HTMLInputElement | null;

    const collectionRadio = document.getElementById(
        "deliveryMethod_collection"
    ) as HTMLInputElement | null;

    const deliveryInfo = document.getElementById("delivery-info");
    const collectionInfo = document.getElementById("collection-info");

    const updateHelpTextVisibility = (): void => {
        // Hide both first
        if (deliveryInfo) {
            deliveryInfo.classList.add("d-none");
        }

        if (collectionInfo) {
            collectionInfo.classList.add("d-none");
        }

        // Show selected option text
        if (deliveryRadio?.checked && deliveryInfo) {
            deliveryInfo.classList.remove("d-none");
        }

        if (collectionRadio?.checked && collectionInfo) {
            collectionInfo.classList.remove("d-none");
        }
    };

    deliveryRadio?.addEventListener("change", updateHelpTextVisibility);
    collectionRadio?.addEventListener("change", updateHelpTextVisibility);

    // Set initial state on load
    updateHelpTextVisibility();
}